/**
 * Où l'on est dans les écrans des présences, et comment ça s'écrit dans une
 * adresse. Sans la base : la page du lien et les tests le lisent tel quel.
 */

/** Les tuiles, un groupe, tout le centre, un enfant. */
export type Vue =
  | { nom: 'groupes' }
  | { nom: 'groupe'; cle: string }
  | { nom: 'centre' }
  | { nom: 'enfant'; registrationId: string };

/** `g/<groupe>`, `tous` ou `e/<inscription>` après la racine ; le reste, c'est les tuiles. */
export function vueDepuisLAdresse(reste: string | undefined): Vue {
  const parts = (reste ?? '').split('/').filter(Boolean);
  if (parts[0] === 'g' && parts[1]) return { nom: 'groupe', cle: parts[1] };
  if (parts[0] === 'tous') return { nom: 'centre' };
  if (parts[0] === 'e' && parts[1]) return { nom: 'enfant', registrationId: parts[1] };
  return { nom: 'groupes' };
}

/** L'adresse d'une vue sous une racine (`/presences/<jeton>`). */
export function adresseDeLaVue(racine: string, vue: Vue): string {
  if (vue.nom === 'groupe') return `${racine}/g/${vue.cle}`;
  if (vue.nom === 'centre') return `${racine}/tous`;
  if (vue.nom === 'enfant') return `${racine}/e/${vue.registrationId}`;
  return racine;
}
